
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/institutions-universities",
      function () {
        return require("private-next-pages/partners/institutions-universities.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/institutions-universities"])
      });
    }
  